import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const MajorContractsMain = lazy(
  () => import('../major-contracts/MajorContractsMain')
);
const MjAwardBonusPackages = lazy(
  () => import('../major-contracts/MjAwardBonusPackages/MjAwardBonusPackages')
);
const AwardEntryForm = lazy(
  () => import('../major-contracts/AwardEntry/AwardEntryForm')
);
const CentralTenderWidget = lazy(
  () => import('../major-contracts/CentralTender/CentralTenderWidget')
);
const CentralTenderUtility = lazy(
  () => import('../major-contracts/CentralTender/CentralTenderUtility')
);
const ArbEligiblesUtility = lazy(
  () => import('../major-contracts/ArbEligibles/ArbEligiblesUtility')
);

const CBTPayors = lazy(() => import('../major-contracts/CBTPayors/CBTPayors'));

export default [
  {
    id: NavConfig.groupConfigs.MAJOR_CONTRACTS.id,
    path: NavConfig.groupConfigs.MAJOR_CONTRACTS.to,
    element: (
      <MajorContractsMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </MajorContractsMain>
    ),

    children: [
      {
        index: true,
        element: <Navigate to={NavConfig.linkConfigs.MJ_AWARD_ENTRY.to} />,
      },
      {
        id: NavConfig.linkConfigs.MJ_AWARD_BONUS_PACKAGES.id,
        path: NavConfig.linkConfigs.MJ_AWARD_BONUS_PACKAGES.to,
        element: <MjAwardBonusPackages />,
      },
      {
        id: NavConfig.linkConfigs.MJ_AWARD_ENTRY.id,
        path: NavConfig.linkConfigs.MJ_AWARD_ENTRY.to,
        element: <AwardEntryForm />,
      },
      {
        id: NavConfig.linkConfigs.MJ_CENTRAL_TENDER.id,
        path: NavConfig.linkConfigs.MJ_CENTRAL_TENDER.to,
        element: <CentralTenderWidget />,
      },
      {
        id: NavConfig.linkConfigs.MJ_CENTRAL_TENDER_UTILITY.id,
        path: NavConfig.linkConfigs.MJ_CENTRAL_TENDER_UTILITY.to,
        element: <CentralTenderUtility />,
      },
      {
        id: NavConfig.linkConfigs.MJ_ARB_ELIGIBLES.id,
        path: NavConfig.linkConfigs.MJ_ARB_ELIGIBLES.to,
        element: <ArbEligiblesUtility />,
      },
      {
        id: NavConfig.linkConfigs.MJ_CBT_PAYORS.id,
        path: NavConfig.linkConfigs.MJ_CBT_PAYORS.to,
        element: <CBTPayors />,
      },
    ],
  },
];
